import { ConfigType } from "src/helpers";

export class Configuration {
    id: number;
    configType: ConfigType;
    value: string;
    dateValue: string;
    timeValue: string;
}
